import React, { useState,useEffect } from "react";
import styles from "./DashboardNavbarMobile.module.css";
import { Link } from "react-router-dom";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { HiMenuAlt3 } from "react-icons/hi";
import logo from "../../assets/images/logo.svg";

import { NavLink } from "react-router-dom";
import {
  RiDashboardLine,
  RiFileList3Line,
  RiSettings4Line,
  RiWallet3Line,
  RiQuestionLine,
} from "react-icons/ri";
import {BiLogOut} from 'react-icons/bi';
import { TiArrowSync } from "react-icons/ti";

import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import countries from "../../assets/images/countries.svg";
import application from "../../assets/images/application.svg";
import home from "../../assets/images/home.svg";
import {AiFillCaretDown} from 'react-icons/ai';
import {useHistory} from 'react-router-dom'


const useStyles = makeStyles({
  list: {
    width: 280,
  },
});

function DashboardNavbarMobile(props) {

  const [avatar,setAvatar] = useState("")
  const [name,setName] = useState("")
  const [email,setEmail] = useState("")

  useEffect(()=>{
    function getWithExpiry(key) {
      const itemStr = localStorage.getItem(key);

      if (!itemStr) {
        return null;
      }

      const item = JSON.parse(itemStr);
      const now = new Date();

      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }
      setAvatar(item.value.user_data.profile_img)
      setName(item.value.user_data.first_name)
      setEmail(item.value.user_data.email)

      return item.value;
    }

    getWithExpiry("userData");
  },[])


  const [value, setValue] = useState(0);

  const data = [
    {
      name: "Dashboard",
      link: "/dashboard/home",
      icon: <RiDashboardLine size={36} />,
    },
    {
      name: "My Applications",
      link: "/dashboard/my-applications",
      icon: <RiFileList3Line size={36} />,
    },
    {
      name: "Transactions",
      link: "/dashboard/transactions",
      icon: <RiWallet3Line size={36} />,
    },
    {
      name: "Plan a trip",
      link: "/dashboard/plan-a-trip",
      icon: <TiArrowSync size={36} />,
    },
    { name: "FAQ", link: "/dashboard/faq", icon: <RiQuestionLine size={36} /> },
    {
      name: "Settings",
      link: "/dashboard/settings",
      icon: <RiSettings4Line size={36} />,
    },
  ];

  const history = useHistory()
  const classes = useStyles();
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const logout = () => {
    localStorage.removeItem("userData");
    history.push("/login");
  }

  const list = (anchor) => (
    <div className={clsx(classes.list)} role="presentation">
      {/* <div className={styles.nav}>
        <Link to="/">
          <img src={logo} alt="Logo" className={styles.logoa} />
        </Link>
        {["left"].map((anchor) => (
          <React.Fragment key={anchor}>
            <Button
              onClick={toggleDrawer("left", false)}
              style={{ outline: "none" }}
            >
              <HiMenuAlt3 className={styles.burger} />
            </Button>
          </React.Fragment>
        ))}
        </div> */}
      <div style={{ marginTop: "50px", }}>
        <List className={styles.sidebar}>
        <NavLink to="/dashboard/settings"  strict>
        <div className={styles.listItemName}>
            <img src={avatar} alt="Avatar" className={styles.avatar} />
            <div className={styles.cont}>
            <h6 className={styles.name}>Hi, <b>{name}</b></h6>
            <h6 className={styles.email}>{email}</h6>
            </div>
            <AiFillCaretDown size={18} color="#D3D6E4" />
          </div>
          </NavLink>
          {data.map((value, index) => (
            <ListItem className={styles.listItemCont} key={index}>
            <NavLink
            // exact
            strict to="/dashboard/"
            to={value.link}
            activeStyle={{
              color: "#5BCFC5",
              backgroundColor: "#EBF8F6",
              fontWeight: "bold",
            }}
            className={styles.listItem}
          >
              <div className={styles.icon}>
                {value.icon}
              </div>
              <div className={styles.text}>
                <span>{value.name}</span>
              </div>
          </NavLink>
          </ListItem>
          ))}
            <ListItem className={styles.listItemCont} onClick={logout}>
            <div
            // exact
            // strict to="/dashboard/"
            // to={value.link}
            // activeStyle={{
            //   color: "#5BCFC5",
            //   backgroundColor: "#EBF8F6",
            //   fontWeight: "bold",
            // }}

            className={styles.listItem}
          >
              <div className={styles.icon}>
              <BiLogOut size={36} />
              </div>
              <div className={styles.text}>
                <span>Logout</span>
              </div>
          </div>
          </ListItem>
        </List>
      </div>
    </div>
  );

  return (
    <div className={styles.main}>
      <div className={styles.nav}>
        <Link to="/">
          <img src={logo} alt="Logo" className={styles.logoa} />
        </Link>
        {["left"].map((anchor) => (
          <React.Fragment key={anchor}>
            <Button
              onClick={toggleDrawer("left", true)}
              style={{ outline: "none" }}
            >
              <HiMenuAlt3 className={styles.burger} />
            </Button>
            <Drawer
              anchor={anchor}
              open={state[anchor]}
              onClose={toggleDrawer("left", false)}
              // BackdropProps={{ invisible: true }}
            >
              {list(anchor)}
            </Drawer>
          </React.Fragment>
        ))}
      </div>

      <BottomNavigation
        value={value}
        onChange={(event, newValue) => {
          setValue(newValue);
        }}
        showLabels
        className={styles.downNavigation}
      >
        <Link to="/dashboard/countries" className={styles.bottomi}>
          <div>
            <img src={countries} alt="Countries" />
          </div>{" "}
          Countries
        </Link>
        
        <Link to="/dashboard/home" className={styles.bottomi}>
          <div>
            <img src={home} alt="Home" />
          </div>{" "}
          Home
        </Link>

        <Link to="/dashboard/my-applications" className={styles.bottomi}>
          <div>
            <img src={application} alt="Application" />
          </div>
          My Applications
        </Link>
      </BottomNavigation>
    </div>
  );
}

export default DashboardNavbarMobile;
